import * as React from "react";

const SvgRequestBudgetCheck = (props) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.813 1.75 5.25 8.313 2.187 5.25 0 7.438l5.25 5.25L14 3.938 11.812 1.75Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgRequestBudgetCheck;
